import { Person } from 'src/app/people/models/person';
import { IMandrillEmailMessageTemplate } from './mandrillEmailTemplate';

export type DeliveryStatus = 'Bounced' | 'Delivered' | 'Rejected';

export interface IEmailMessage {
  id: string;
  subject: string;
  email: string;
  deliveryStatus: DeliveryStatus;
  personId?: string;
  teamId?: string;
  teamName?: string;
  applicationId?: string;
  sentOn?: string;
  openedOn?: string;
  clickedOn?: string;
  messageType: string;
  sender: string;
  senderName: string;
  replyTo: string;
  bccAddresses: string[];
  template: IMandrillEmailMessageTemplate;
  reminderId?: string;
}

export interface IEmailMessageContent {
  id: string;
  html?: string | null;
}

export interface IEmailMessageWrite {
  subject: string;
  email: string;
  senderName: string;
  replyTo: string;
}

export enum EmailType {
  'Single',
  'Bulk',
  'TeamInvitationReminder',
  'TeamMembers',
  'Invitees',
  'Invitee',
  'Survey',
  'TeamForm',
  'SurveyReminder',
}

export enum MessageType {
  Delivered = 'Delivered',
  Scheduled = 'Scheduled',
}
